import constants from '../../../../src/client/ahm-constants';
import ProductListingAllPage, {
  createProductListingAllGetStaticProps,
} from '../../../utils/needs-product-listing-all-page';

export const getStaticProps = createProductListingAllGetStaticProps(constants.CUSTOMER_NEEDS.EXTRAS_COVER);

export default ProductListingAllPage;
